import PersonalDocumentsStep from './components/steps/PersonalDocumentsStep';
import BankDataStep from './components/steps/BankDataStep';
import ComplementaryInfoStep from './components/steps/ComplementaryInfoStep';
import ContractsStep from '../EnrollmentLegal/components/Wizard/Steps/Contract';
import FinalStep from './components/steps/FinalStep';
import InvestorProfile from '../EnrollmentLegal/components/Wizard/Steps/InvestorProfile';

export default [
  {
    title: 'Documentos personales',
    description: 'Ingresa todos tus datos para continuar con tu enrolamiento.',
    Component: PersonalDocumentsStep,
  },
  {
    title: 'Datos bancarios y financieros',
    description: 'Ingresa tus datos bancarios y financieros.',
    Component: BankDataStep,
  },
  {
    title: 'Perfil inversionista',
    description: 'Responde una breve encuesta para conocer tu perfil de inversión.',
    Component: InvestorProfile,
    usesTwoColumns: true,
  },
  {
    title: 'Información complementaria',
    description: ' ',
    Component: ComplementaryInfoStep,
  },
  {
    title: 'Contratos',
    description: ' ',
    Component: ContractsStep,
  },
  {
    title: '¡Todo listo!',
    description: ' ',
    Component: FinalStep,
  },
];
